// pages/Home.js (Updated Why Choose Us section)
import React, { useEffect, useState, useRef } from 'react';
import { Carousel } from 'primereact/carousel';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Badge } from 'primereact/badge';
import classNames from 'classnames';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { useNavigate } from 'react-router-dom';
import NewMandatory from './NewMandatory';
import { Dialog } from 'primereact/dialog';

const Home = () => {
  const [highlights, setHighlights] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    setHighlights([
      {
        id: 1,
        title: 'Shaping Bright Minds for a Brighter Future!',
        content: 'Join us for the new academic year.',
        image: '/images/hbanner5.png',
      },
      {
        id: 2,
        title: 'Empowering Students to Learn, Lead, and Succeed!',
        content: 'Celebrating freedom with pride.',
        image: '/images/hbanner1.png',
      },
      {
        id: 3,
        title: 'Where Learning Meets Excellence!',
        content: 'Latest updates on school achievements.',
        image: '/images/hbanner3.png',
      },
      {
        id: 4,
        title: 'Where Learning Meets Excellence!',
        content: 'Latest updates on school achievements.',
        image: '/images/hbanner4.png',
      },
      {
        id: 5,
        title: 'Where Learning Meets Excellence!',
        content: 'Latest updates on school achievements.',
        image: '/images/hbanner2.png',
      },
    ]);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleInquiryClick = () => {
    window.open('https://dis.myclassboard.com/OnlineForm/AdmissionEnquiry1?ORGGUID=F70D26E0-EEB6-42B1-82C3-38F7B7DE57E8&BGUID=8D2BDF7E-EC5F-400B-8483-0210D8D5990D&SourceGuid=32464328-7FBD-4659-94B0-F8A786E4414E', '_blank');
    setShowBanner(false);
  };

  const navigate = useNavigate();

  const quickLinks = [
    {
      label: 'Picture Gallery',
      icon: 'pi pi-images',
      path: '/photo'
    },
    {
      label: 'Video Gallery',
      icon: 'pi pi-video',
      path: '/video' // You can add this route later
    },
    {
      label: 'Blogs',
      icon: 'pi pi-pencil',
      path: '/blogs' // You can add this route later
    },
    {
      label: 'Sports Corner',
      icon: 'pi pi-trophy',
      path: '/sports' // You can add this route later
    },
  ];

  const handleQuickLinkClick = (path) => {
    navigate(path);
  };


  const responsiveOptions = [
    { breakpoint: '1024px', numVisible: 3, numScroll: 3 },
    { breakpoint: '768px', numVisible: 2, numScroll: 2 },
    { breakpoint: '560px', numVisible: 1, numScroll: 1 },
  ];

  const features = [
    {
      icon: '📚',
      title: 'Qualitative Focus',
      description: 'Creative learning outcomes are developed, our students are trained, not merely to be good persons, but personalities.'
    },
    {
      icon: '💻',
      title: 'Technology',
      description: 'The use of technology in learning is purposive and controlled. It is also implemented in evaluating and managing solutions.'
    },
    {
      icon: '🛡️',
      title: 'Health & Safety',
      description: 'Our students feel safe and secure in a protected environment where teachers and helpers are always around, to escort and guide.'
    },
    {
      icon: '🏆',
      title: 'Sports',
      description: 'We promote self-confidence, teamwork and leadership through various sports and games.'
    }
  ];

  // 🧩 Enhanced template for carousel item
  const itemTemplate = (highlight) => {
    return (
      <div className="grid align-items-center hero-section" style={{ minHeight: '450px' }}>
        <div className="col-12 md:col-12">
          <div className="hero-image-container">
            <img
              src={highlight.image}
              alt={highlight.title}
              style={{
                width: '100%',
                // height: '450px',
                objectFit: 'cover',
                borderRadius: '20px',
                // boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                transition: 'transform 0.3s ease'
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="home-container">
      {/* Enhanced Hero Carousel */}
      <div className="hero-carousel-section">
        <div className="grid">
          <div className="col-12">
            <Carousel
              value={highlights}
              numVisible={1}
              numScroll={1}
              responsiveOptions={responsiveOptions}
              circular
              autoplayInterval={4000}
              showIndicators={true}
              showNavigators={true}
              className="enhanced-carousel"
              itemTemplate={itemTemplate}
            />
          </div>
        </div>
      </div>

      {/* Updated Why Choose Us Section - 4 Features in One Row */}
      <div className="why-choose-section" ref={sectionRef}>
        <div className="text-center mb-6">
          {/* <div className="section-badge mb-3 animate-on-scroll">
            <Badge 
              value="🎯 Why Choose Us" 
              className="p-2"
              style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)'
              }}
            />
          </div> */}

          <div className="animate-on-scroll">
            <h1 className="text-4xl font-bold mb-3">
              <span
                className="gradient-text"
                style={{
                  background: 'linear-gradient(135deg, #03397d 0%, #03397d 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Advantages
              </span>
              {' '}
              {/* <span className="text-gray-800">  Our Success</span> */}
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We are committed to providing exceptional education that nurtures young minds and prepares them for a successful future.
            </p>
          </div>
        </div>

        {/* 4 Features Grid */}
        <div className="grid features-grid">
          {features.map((feature, index) => (
            <div key={index} className="col-12 md:col-6 lg:col-3">
              <Card
                className={classNames(
                  'feature-card animate-on-scroll border-1 surface-border h-full',
                  'shadow-2 hover:shadow-4 transition-all transition-duration-300 '
                )}
                style={{
                  borderRadius: '16px',
                  border: 'none',
                  // background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                  background: 'linear-gradient(135deg, #03397d 0%, #03397d 100%)',
                  transitionDelay: `${index * 100}ms`,
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                {/* Animated Background Element */}
                <div
                  className="feature-background"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    transform: 'scaleX(0)',
                    transformOrigin: 'left',
                    transition: 'transform 0.6s ease'
                  }}
                />

                <div className="text-center p-4">
                  {/* Icon Container */}
                  <div
                    className="icon-container mx-auto mb-4 flex align-items-center justify-content-center"
                    style={{
                      width: '80px',
                      height: '80px',
                      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                      borderRadius: '50%',
                      fontSize: '2.5rem',
                      boxShadow: '0 8px 25px rgba(16, 185, 129, 0.15)',
                      transition: 'all 0.4s ease'
                    }}
                  >
                    {feature.icon}
                  </div>

                  {/* Title */}
                  <h3
                    className="text-xl font-bold mb-3"
                    style={{
                      color: 'white',
                      minHeight: '3rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p
                    className=" leading-relaxed m-0"
                    style={{
                      fontSize: '0.95rem',
                      lineHeight: '1.6',
                      color: '#eaeaea',
                    }}
                  >
                    {feature.description}
                  </p>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>

      <Divider className="my-8" />
     <div className="relative mb-4">
  {/* Background Image */}
  <div className="hidden absolute w-full h-full z-0 md:block ">
    <img
      src="/images/img.jpg"
      alt="School Building"
      className="w-full h-full object-cover"
      style={{ minHeight: '400px' }} // Reduced from 500px for mobile
    />
    {/* Dark overlay for better text readability */}
    <div className="absolute inset-0 bg-black bg-opacity-40"></div>
  </div>

  {/* Content Strip - positioned to the right on desktop, centered on mobile */}
  <div className="relative z-1 pt-6 pb-6 mb-8">
    <div className="container mx-auto px-4">
      {/* Center on mobile, end on desktop */}
      <div className="flex justify-content-center md:justify-content-end">
        <div className="col-12 lg:col-6">
          {/* Card with responsive padding */}
          <div className="bg-white border-round-lg shadow-3 p-4 md:p-5">
            {/* Header Section */}
            <div className="text-center lg:text-left mb-5">
              <span className="block text-primary text-sm md:text-lg font-semibold mb-2">
                OUR SUCCESS
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3" style={{ color: '#03438F' }}>
                Why Choose DIS?
              </h2>
              <p className="text-gray-700 line-height-3 text-sm md:text-base">
                The main premise of starting the school is to ensure a more ethical and responsible future generation.
                Hence a lot of emphasis is laid on academics, value education and discipline.
              </p>
            </div>

            {/* Features List with responsive icon sizes */}
            <div className="space-y-3 md:space-y-4">
              <div className="flex align-items-center mb-2">
                <div className="w-2rem h-2rem md:w-3rem md:h-3rem border-round-lg flex align-items-center justify-content-center mr-3" style={{ background: '#F57A25' }}>
                  <span className="text-sm md:text-xl text-white">✓</span>
                </div>
                <span className="text-base md:text-lg font-semibold text-gray-800">Student Centric Approach</span>
              </div>

              <div className="flex align-items-center mb-2">
                <div className="w-2rem h-2rem md:w-3rem md:h-3rem border-round-lg flex align-items-center justify-content-center mr-3" style={{ background: '#F57A25' }}>
                  <span className="text-sm md:text-xl text-white">✓</span>
                </div>
                <span className="text-base md:text-lg font-semibold text-gray-800">Experienced Faculty</span>
              </div>

              <div className="flex align-items-center mb-2">
                <div className="w-2rem h-2rem md:w-3rem md:h-3rem border-round-lg flex align-items-center justify-content-center mr-3" style={{ background: '#F57A25' }}>
                  <span className="text-sm md:text-xl text-white">✓</span>
                </div>
                <span className="text-base md:text-lg font-semibold text-gray-800">Best Practices</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      {/* <NewMandatory/> */}

      {/* Enhanced Notice Board and Quick Links */}
      <div className="info-section">
        <div className="grid">
          <div className="col-12 md:col-8">
            <div className="notice-board-card">
              <div className="card-header">
                <div className="flex align-items-center">
                  <span className="text-2xl mr-3">📢</span>
                  <h2 className="text-2xl font-bold text-primary m-0">Notice Board</h2>
                </div>
              </div>
              <div className="notice-list ">
                <div className="notice-item  bg-primary">
                  <div className="notice-icon">📄</div>
                  <div className="notice-content">
                    <h4 className="notice-title ">Circulars</h4>
                    <p className="notice-text">Latest announcements and updates</p>
                  </div>
                </div>
                <div className="notice-item  bg-primary">
                  <div className="notice-icon">🎓</div>
                  <div className="notice-content">
                    <h4 className="notice-title">Admissions</h4>
                    <p className="notice-text">Open for 2025-26 academic year</p>
                  </div>
                </div>
                <div className="notice-item  bg-primary">
                  <div className="notice-icon">🏃</div>
                  <div className="notice-content">
                    <h4 className="notice-title">Events</h4>
                    <p className="notice-text">Sports Day on Aug 29, 2025</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 md:col-4">
            <div className="quick-links-card">
              <div className="card-header">
                <div className="flex align-items-center">
                  <span className="text-2xl mr-3">🔗</span>
                  <h2 className="text-2xl font-bold text-primary m-0">Quick Links</h2>
                </div>
              </div>
              <div className="quick-links-grid">
                {quickLinks.map((link, index) => (
                  <Button
                    key={index}
                    label={link.label}
                    icon={link.icon}
                    className="quick-link-button"
                    onClick={() => handleQuickLinkClick(link.path)}
                    style={{
                      background: 'linear-gradient(135deg, #03397d 0%, #03397d 100%)',
                      border: 'none',
                      borderRadius: '12px',
                      padding: '1rem',
                      marginBottom: '0.75rem',
                      width: '100%',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Contact and Location Section */}
      < div className="contact-section mt-8" >
        <div className="grid">
          <div className="col-12 md:col-6 text-left">
            <div className="contact-card">
              <div className="card-header">
                <div className="flex align-items-center">
                  <span className="text-2xl mr-3">📞</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Contact Information</h3>
                </div>
              </div>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <div className="contact-info">
                    <h4 className="contact-label">Address</h4>
                    <p className="contact-text text-primary">D.No.27-13-2, Rajupeta, Tiruvuru, Tiruvuru Mandal, NTR District - 521235.</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📱</span>
                  <div className="contact-info">
                    <h4 className="contact-label">Phone</h4>
                    <p className="contact-text text-primary">1800 891 1256, 8886421212, 8886521212</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">✉️</span>
                  <div className="contact-info">
                    <h4 className="contact-label">Email</h4>
                    <p className="contact-text text-primary">
                      enquiry@dreamindia.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6">
            <div className="location-card">
              <div className="card-header">
                <div className="flex align-items-center">
                  <span className="text-2xl mr-3">🗺️</span>
                  <h3 className="text-2xl font-bold text-primary m-0">Our Location</h3>
                </div>
              </div>
              <div className="map-container">
                <div className="map-placeholder">
                  <iframe
                    title="Dream India School Location"
                    src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=14-1-2,%20near%20ASHTA%20LAKSHMI%20TEMPLE,%20Rajupeta,%20Tiruvuru,%20Andhra%20Pradesh%20521235+(Dream%20India%20School)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                    width="100%"
                    height="400"
                    style={{ border: 0, borderRadius: '15px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          visible={showBanner}
          onHide={() => setShowBanner(false)}
          // header="Admission Inquiry 2026-27"
          breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          style={{ width: '50vw' }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-column align-items-center">
            <img
              src="/images/aff_banner.png" 
              alt="Admission Open Banner"
              style={{ width: '100%', borderRadius: '8px' }}
              className="mb-4"
            />

            {/* Inquiry Button */}
            <Button
              label="Click Here"
              // icon="pi pi-external-link"
              className="p-button-raised p-button-warning font-bold w-2"
              style={{  borderRadius: '8px' }}
              onClick={handleInquiryClick}
            />
          </div>
        </Dialog>
      </div >
      < style jsx > {`
        .home-container {
          min-height: 100vh;
        }
   
        .enhanced-carousel {
          background: transparent;
          border: none;
        }
        
        .hero-section {
          // background: rgba(255, 255, 255, 0.95);
          border-radius: 20px;
        }
        
        .hero-image-container {
          position: relative;
        }
        
        .hero-image-container img:hover {
          transform: scale(1.02);
        }
        
        .why-choose-section {
          background: white;
          border-radius: 20px;
          padding: 2rem 2rem;
          margin: 1rem 0;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        }
        
        .features-grid {
          margin: 3rem 0;
        }
        
        .feature-card {
          position: relative;
          overflow: hidden;
          cursor: pointer;
        }
        
        .feature-card:hover {
          transform: translateY(-10px);
        }
        
        .feature-card:hover .feature-background {
          transform: scaleX(1);
        }
        
        .feature-card:hover .icon-container {
          transform: scale(1.1) rotate(5deg);
          box-shadow: 0 12px 30px rgba(16, 185, 129, 0.25);
        }
        
        .icon-container {
          transition: all 0.4s ease;
        }
        
        .info-section {
          margin: 3rem 0;
        }
        
        .notice-board-card, .quick-links-card, .contact-card, .location-card {
          background: #;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          height: 100%;
        }
        
        .card-header {
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #e2e8f0;
        }
        
        .notice-item, .contact-item {
          display: flex;
          align-items: center;
          padding: 1rem;
          margin-bottom: 1rem;
          background: #f8fafc;
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        
        .notice-item:hover, .contact-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        
        .notice-icon, .contact-icon {
          font-size: 1.5rem;
          margin-right: 1rem;
        }
        
        .notice-title, .contact-label {
          font-weight: 600;
          color: orange;
          margin-bottom: 0.25rem;
          text-align: left;
        }
        
        .notice-text, .contact-text {
          color: white;
          margin: 0;
        }
        
        .quick-link-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4) !important;
        }
        
        .map-container {
          height: 400px;
          border-radius: 15px;
          overflow: hidden;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        .animate-on-scroll {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s ease-out;
        }

        .animate-on-scroll.animate-in {
          opacity: 1;
          transform: translateY(0);
        }

        @media (max-width: 768px) {
          .home-container {
            padding: 1rem;
          }
          
          .hero-carousel-section {
            padding: 1rem;
          }
          
          .why-choose-section {
            padding: 2rem 1rem;
          }
          
          .notice-board-card, .quick-links-card, .contact-card, .location-card {
            padding: 1.5rem;
            margin-bottom: 1rem;
          }
          
          .feature-card:hover {
            transform: none;
          }
          
          .notice-item:hover, .contact-item:hover {
            transform: none;
          }
        }

        @media (max-width: 1024px) {
          .features-grid .col-lg-3 {
            flex: 0 0 50%;
            max-width: 50%;
          }
        }
      `}</style >
    </div >);
};

export default Home;